module.exports = __webpack_public_path__ + "static/media/prop-2.7b297a86.jpeg";